/**
 * Ryan O'Dowd
 * 2023-05-28
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import {
  TouchableOpacity,
  View,
} from 'react-native';
import Text from '@components/common/Text';
import TranslationSelectionDialog from '@components/TranslationSelectionDialog';
import getStyles from './styles';
import hooks from '@hooks';

const BookAndTranslationSelection = (props: BookAndTranslationSelectionProps) => {
  const styles = hooks.useStyles(getStyles);

  const [_isTranslationMenuOpen, setIsTranslationMenuOpen] = useState(false);

  return (
    <View style={styles.headerPassageAndTranslation}>
      <TouchableOpacity
        style={styles.bookItem}
        onPress={props.onPress}
      >
        <Text style={styles.bookText}>{props.bookAndChapter}</Text>
      </TouchableOpacity>
      <View style={styles.verticalSeparator} />
      <TouchableOpacity
        style={styles.translationItem}
        onPress={() => setIsTranslationMenuOpen(true)}
      >
        <Text style={styles.translationText}>{props.selectedTranslation.abbreviation}</Text>
      </TouchableOpacity>
      <TranslationSelectionDialog
        isOpen={_isTranslationMenuOpen}
        onClose={() => setIsTranslationMenuOpen(false)}
        autoClose={true}
      />
    </View>
  );
};

class BookAndTranslationSelectionProps {
  bookAndChapter: string;
  onPress: () => void;
  selectedTranslation: any;

  selectedChapter: {
    id: number;
    book_id: number;
    chapter_number: number;
  }; // @TODO: chapter type
};

export default BookAndTranslationSelection;
